import { useRouter } from "next/router";
import Link from "next/link";
import styles from "./styles.module.scss";

const Breadcrumb = ({ customBreadcrumbs = {} }) => {
  const router = useRouter();
  const { pathname, query } = router;

  // Generate breadcrumbs from the URL structure
  let breadcrumbs = [{ href: "/", label: "Home" }];
  const pathSegments = pathname.split("/").filter(Boolean);

  // Don't include the last segment in the breadcrumbs
  const validSegments = pathSegments.slice(0, -1);

  validSegments.forEach((segment, index) => {
    const href = `/${validSegments.slice(0, index + 1).join("/")}`;
    const label = segment.replace(/-/g, " "); // Convert kebab-case to readable format

    breadcrumbs.push({
      href,
      label: customBreadcrumbs[href] || label.charAt(0).toUpperCase() + label.slice(1),
    });
  });

  // Handle custom breadcrumbs for `/product/[id]`
  if (pathname.startsWith("/product/") && query.id) {
    breadcrumbs = [{ href: "/shop", label: "Shop" }]; // Remove "Home" and start from "Shop"

    if (customBreadcrumbs.productData) {
      const { kind, root_subtype } = customBreadcrumbs.productData;

      if (kind) {
        breadcrumbs.push({
          href: `/shop/${kind.toLowerCase().replace(/\s+/g, "-")}`,
          label: kind,
        });
      }
      if (root_subtype) {
        breadcrumbs.push({
          href: `/shop/${kind.toLowerCase().replace(/\s+/g, "-")}?subcategory=${kind.toLowerCase().replace(/\s+/g, "-")}:${root_subtype.toLowerCase().replace(/\s+/g, "+")}`,
          label: root_subtype,
        });
      }
    }
  }

  if (breadcrumbs.length === 0) return null; // If no breadcrumbs, don't render

  return (
    <nav className={styles.breadcrumb}>
      <ul>
        {breadcrumbs.map((crumb, index) => (
          <li key={index}>
            <Link href={crumb.href}>{crumb.label}</Link>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default Breadcrumb;
